import React from 'react';
import { useTranslation } from 'react-i18next';
import './SalesShareChart.css';

const RADIUS = 80;
const STROKE_WIDTH = 34;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const SEGMENT_GAP = 1.2; // white gap between segments, in px along the ring

// Donut chart with a legend; labels go through i18n so the chart works in every site language.
// data: [{ label, value (percent), color }] in clockwise order
const SalesShareChart = ({ data, startAngle = -90 }) => {
    const { t, i18n } = useTranslation();
    const locale = i18n.language === 'pt' ? 'pt-BR' : 'en-US';

    const formatPercent = (value, digits = 1) =>
        (value / 100).toLocaleString(locale, { style: 'percent', minimumFractionDigits: digits, maximumFractionDigits: digits });

    let offset = 0;
    const segments = data.map((item) => {
        const length = (item.value / 100) * CIRCUMFERENCE;
        const segment = { ...item, length, offset };
        offset += length;
        return segment;
    });

    return (
        <div className="sales-share-chart">
            <div className="sales-share-chart__donut">
                <svg viewBox="0 0 200 200" role="img" aria-label={data.map((item) => `${t(item.label)} ${formatPercent(item.value)}`).join(', ')}>
                    <g transform={`rotate(${startAngle} 100 100)`}>
                        {segments.map((segment) => (
                            <circle
                                key={segment.label}
                                cx="100"
                                cy="100"
                                r={RADIUS}
                                fill="none"
                                stroke={segment.color}
                                strokeWidth={STROKE_WIDTH}
                                strokeDasharray={`${Math.max(segment.length - SEGMENT_GAP, 0)} ${CIRCUMFERENCE}`}
                                strokeDashoffset={-segment.offset}
                            />
                        ))}
                    </g>
                    <text x="100" y="100" className="sales-share-chart__total" textAnchor="middle" dominantBaseline="central">
                        {formatPercent(100, 0)}
                    </text>
                </svg>
            </div>

            <ul className="sales-share-chart__legend">
                {data.map((item) => (
                    <li key={item.label} className="sales-share-chart__legend-item">
                        <span className="sales-share-chart__swatch" style={{ backgroundColor: item.color }} />
                        <span>
                            <span className="sales-share-chart__value">{formatPercent(item.value)}</span>
                            <span className="sales-share-chart__label">{t(item.label)}</span>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SalesShareChart;
